import {CuppaNotification} from "../../../cuppa/components/cuppa.notification";
import {log} from "../../../cuppa/cuppa";

export function Notification({title, message, autoCloseTime = 99000, closeCallback, openCallback, removeCallback, closeText = 'Close', openText = 'Open', hoverAvoidAutoClose = true, leaveEnableAutoClose = true} = {}){

	function onRemoved(){
		if(removeCallback) removeCallback();
	}

	function onClosed(){
		if(closeCallback) closeCallback();
	}

	function onOpen(){
		if(openCallback) openCallback();
	}

	return (
		<div>
			<cuppa-notification
				class={'ani-fade-right bg-progress color-white'}
				title={title}
				message={message}
				auto-close-time={autoCloseTime}
				close-text={closeText}
				open-text={openText}
				style={{position:'relative', top:0, right:0, marginBottom:5, minWidth:300}}
				hover-avoid-auto-close={hoverAvoidAutoClose}
				leave-enable-auto-close={leaveEnableAutoClose}
				ref={el=>{ if(el){ el.removedCallback = onRemoved; el.closeCallback = onClosed; el.openCallback = onOpen; } }}
			></cuppa-notification>
		</div>
	)
}
